import { useSyncExternalStore } from "react";
import {
	getBridgedOnlineStatus,
	subscribeBridgedOnlineStatus,
} from "web_myplann/Infrastructure/Hooks/onlineStatusStore";

function subscribeNavigator(callback: () => void) {
	window.addEventListener("online", callback);
	window.addEventListener("offline", callback);
	return () => {
		window.removeEventListener("online", callback);
		window.removeEventListener("offline", callback);
	};
}

export function useOnlineStatus() {
	const bridgedOnline = useSyncExternalStore(
		subscribeBridgedOnlineStatus,
		getBridgedOnlineStatus,
		() => true,
	);

	const navigatorOnline = useSyncExternalStore(
		subscribeNavigator,
		() => navigator.onLine,
		() => true,
	);

	return window.ReactNativeWebView ? bridgedOnline : navigatorOnline;
}
